// components/features/sectors/SectorRow.tsx
import { Sector } from "@cabukaka/types";
import TableRow from "../../ui/TableRow";
import { Grid3X3, Tag } from "lucide-react";

interface SectorRowProps {
  sector: Sector;
  onAction: (sector: Sector) => void;
  onSelect?: (sector: Sector, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function SectorRow({ 
  sector, 
  onAction, 
  onSelect,
  isSelected = false,
  selectable = false
}: SectorRowProps) {
  return (
    <TableRow
      item={sector}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {/* Colonne Secteur - toujours visible */}
      <td className="py-3 px-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            {sector.logo ? (
              <img src={sector.logo} alt={sector.name} className="w-6 h-6 object-contain" />
            ) : (
              <Grid3X3 size={18} className="text-primary" />
            )}
          </div>
          <div>
            <span className="font-medium text-gray-800 block">
              {sector.name}
            </span>
            {sector.slug && (
              <span className="text-xs text-gray-400">/{sector.slug}</span>
            )}
          </div>
        </div>
      </td>

      {/* Colonne Nombre de catégories - cachée sur mobile */}
      <td className="hidden sm:table-cell py-3 px-4">
        <div className="flex items-center gap-2">
          <Tag size={14} className="text-gray-400" />
          <span className="text-gray-600">{sector.order || 0}</span>
        </div>
      </td>

    
    </TableRow>
  );
}